import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Typography,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import debounce from "lodash/debounce";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useMutation, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ModalCancel from "../../../components/modals/ModalCancel";
import ModalCheckbox from "../../../components/modals/ModalCheckbox";
import { BRANCHID, TABLE_FILTER } from "../../../config/cacheKey";
import {
  BranchUsers,
  GetBranchUsersHeader,
  GetBranchUsersResponse,
} from "../../../models/branch.model";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import { IDropdownResponse } from "../../../models/dropdown.model";
import { Filter, PaginationInfo } from "../../../models/store.model";
import {
  AddUser,
  DeleteUser,
  GetBranchUsers,
} from "../../../services/branch.service";
import { GetAllUsers } from "../../../services/dropdown.service";
import { GetStoreListReportExcel } from "../../../services/store.service";
import BranchHeader from "../../supplierSettelments/components/BranchHeader";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "fullName", label: "نام و نام خانوادگی" },
  { id: "nationalCode", label: "کدملی" },
  { id: "mobileNumber", label: "شماره موبایل" },
  { id: "birthDatePersian", label: "تاریخ تولد" },
  { id: "isActive", label: "وضعیت" },
];

export default function BranchUserTable() {
  const branchId = localStorage.getItem(BRANCHID)!;
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [delId, setDelId] = useState<number>();
  const [filteredData, setFilteredData] = useState<BranchUsers[]>([]);
  const jsonFile = useSelector((state: any) => state.style);
  const [allStoresAndBranches, setAllStoresAndBranches] = useState<any[]>();
  const [changeValue, setChangeValue] = useState<any[]>([]);
  // const muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: "#82B1FF !important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  let row: any;
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [isExpanded, setExpanded] = useState(true);
  const [data, setData] = useState<BranchUsers[]>([]);
  const [branchUserData, setBranchUserData] = useState<
    GetBranchUsersResponse
  >();

  const [valueTitle, setValueTitle] = useState<string>();
  const [branchUsersHeader, setBranchUsersHeader] = useState<
    GetBranchUsersHeader
  >();
  const [valueIsActiveSelect, setValueIsActiveSelect] = useState<boolean>();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 1;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  useEffect(() => {
    if (changeValue.length === 0) return;
  }, [changeValue]);
  React.useEffect(() => {
    GetBranchUsersMutation({ branchId: parseInt(branchId) });
    GetAllUsersMutation({ title: "" });
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueTitle(filterData!.title!);
        setValueIsActiveSelect(filterData!.isActive!);
      }
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = new Filter();
      setValueFilterData(filter);
    }
    // fillData(filterData!);
  }, []);

  const { mutateAsync: GetBranchUsersMutation } = useMutation(GetBranchUsers, {
    onSuccess: (data: ApiResultModel<GetBranchUsersResponse>) => {
      setBranchUserData(data.data);
      setData(data.data!.branchUsers);
      setFilteredData(data.data?.branchUsers || []);
      const branchUsersHeader = {
        id: data.data?.id,
        logoBase64: data.data?.logoBase64,
        storeTitle: data.data?.storeTitle,
        isActive: data.data?.isActive,
        type: data.data?.type,
        address: data.data?.address,
        phoneNumbers: data.data?.phoneNumbers,
      } as GetBranchUsersHeader;
      setBranchUsersHeader(branchUsersHeader);
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 1;
      pageInfoModel.total = data.data.branchUsers.length;
    },
  });
  const { mutateAsync: GetAllUsersMutation } = useMutation(GetAllUsers, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      setAllStoresAndBranches(data.data);
    },
  });
  const { mutateAsync: AddUserMutation } = useMutation(AddUser, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.data === true) {
        GetBranchUsersMutation({ branchId: parseInt(branchId) });
      }
    },
  });
  const { mutateAsync: DeleteUserMutate } = useMutation(DeleteUser, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess === true) {
        GetBranchUsersMutation({ branchId: parseInt(branchId) });
      } else toast.error(data.data);
    },
  });

  const { mutateAsync: GetStoreListReportExcelMutate } = useMutation(
    GetStoreListReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const filter = new Filter();
  const handelDetail = (id: number) => {
    // history.push({
    //   pathname: "/store/StoreDetail",
    // });
    // localStorage.setItem(STOREID, id.toString());
  };

  const [isShow, setIsShow] = useState(true);

  let exportExcel = () => {
    GetStoreListReportExcelMutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };

  const addUser = () => {
    setOpenAddModal(!openAddModal);
  };
  const openModalDeleteImage = () => {
    setOpenModal(!openModal);
  };
  const deleteImage = () => {
    DeleteUserMutate({ branchId: parseInt(branchId), userId: delId! });
  };
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      if (branchUserData?.id) {
        const filtered = branchUserData.branchUsers.filter((user) =>
          columns.some(
            (column) =>
              column.id &&
              user[column.id as keyof BranchUsers]
                ?.toString()
                .toLowerCase()
                .includes(value.toLowerCase())
          )
        );
        setFilteredData(filtered);
      }
    }, 300),
    [branchUserData]
  );
  const handleSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };
  useEffect(() => {
    if (changeValue.length === 0) return;
    let userIds: number[] = changeValue.map((user: any) => user.id);
    AddUserMutation({ branchId: parseInt(branchId), userIds: userIds });
  }, [changeValue]);
  return (
    <div>
      <Grid>
        <BranchHeader headerData={branchUsersHeader} />
      </Grid>
      <Grid container spacing={2} style={{ marginTop: "0px" }}>
        <Grid item xs={6} style={{ alignContent: "center", paddingTop: "0px" }}>
          <Button onClick={addUser}>
            <AddCircleOutlineIcon />
            <span
              style={{
                fontWeight: "bold",
                fontSize: "13px",
                paddingRight: "5px",
              }}
            >
              افزودن کاربر شعبه
            </span>
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            placeItems: "end",
            alignContent: "center",
            paddingTop: "0px",
          }}
        >
          <Paper
            elevation={0}
            style={{
              border: ".9px solid #DAE0E4",
              display: "flex",
              borderRadius: "3px",
              height: "35px",
              width: "20vw",
              marginRight: "10px",
              margin: "10px",
              direction: "rtl",
              marginLeft: "0px",
            }}
            square={true}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                paddingX: "16px",
                height: "30px !important",
              }}
              placeholder="جستجو"
              onChange={handleSearchInput}
              value={searchTerm}
            />
            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
      {filteredData && filteredData.length > 0 ? (
        <>
          <div className="cardTableBorder ">
            <TableContainer
              style={{ background: "#fff", direction: "rtl" }}
              className={`${filteredData?.length > 0 ? "boxScrollSubmit" : ""}`}
            >
              <Table
                stickyHeader
                aria-label="sticky table "
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                      style={{ width: "5px" }}
                    >
                      ردیف
                    </TableCell>
                    {columns?.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      <MoreHorizIcon />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>

                <TableBody
                  style={{
                    height: "30px",
                    minHeight: "30px",
                  }}
                >
                  {filteredData?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0
                            ? "rowTBodyE  borderRight borderLeft"
                            : "rowTBodyO  borderRight borderLeft"
                        }${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // key={row.loanRequestId}
                        selected={selectedRow === rowIndex}
                      >
                        <TableCell
                          className="textFont12"
                          style={{ width: "5px" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns?.map((column) => {
                          const value = row[column.id as keyof BranchUsers];
                          return (
                            <TableCell
                              onClick={() => handelDetail(row.id)}
                              className="textFont12 nowrapClass"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat ? (
                                column.format(value)
                              ) : column.id === "isActive" ? (
                                value === true ? (
                                  <b style={{ color: "#28A745" }}>فعال</b>
                                ) : (
                                  <b style={{ color: "#E6123D" }}>غیرفعال</b>
                                )
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          onClick={() =>
                            `${
                              row.canBeDeleted
                                ? (openModalDeleteImage(), setDelId(row.id))
                                : setDelId(row.id)
                            }`
                          }
                          sx={{ cursor: "pointer", color: "#1D4A87" }}
                          className="textFont12 nowrapClass"
                        >
                          {row.canBeDeleted ? <DeleteOutlineIcon /> : ""}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      ) : (
        <div
          style={{
            backgroundColor: "#F9FCFE",
            border: "#DAE0E4",
            height: " calc(90vh - 22vh)",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <div>
            <img
              src="/images/nouser.jpg"
              alt="no user"
              style={{ width: "10%", height: "10%" }}
            />
          </div>
          <Typography style={{ color: "#9AAFC4", fontSize: "20px" }}>
            کاربری ثبت نشده است
          </Typography>
        </div>
      )}
      {openModal === true ? (
        <ModalCancel
          title={""}
          bgColor={"kamanColor"}
          setValue={deleteImage}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : (
        ""
      )}
      {openAddModal === true ? (
        <ModalCheckbox
          openModal={openAddModal}
          setOpenModal={setOpenAddModal}
          allStoresAndBranches={allStoresAndBranches!}
          setChangeValue={setChangeValue}
          title={"افزودن کاربر شعبه"}
          label={"نام و نام خانوادگی - کدملی(شماره همراه)"}
          titleChip={"کاربران اضافه شده"}
        />
      ) : null}
    </div>
  );
}
